import { render, staticRenderFns } from "./MdiIcon.vue?vue&type=template&id=310d716c&"
import script from "./MdiIcon.vue?vue&type=script&lang=js&"
export * from "./MdiIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports